<template>
    
      <div class="list">
          <div v-if="change==='list'"> 
                <el-form :inline="true" :model="formInline" label-position="left"  class="demo-form-inline" >
         
                    <el-form-item label="学校:">
                         <el-select v-model="formInline.schoolId" filterable placeholder="请选择" @change="changeSchoool">
                                    <el-option
                                    v-for="item in school"
                                    :label="item.name"
                                    :value="item.id">
                                    </el-option>
                        </el-select>       
                    </el-form-item>
                    <el-form-item label="班级:"   >
                    <el-select v-model="classid" placeholder="请选择" @change="changeClass">
                    <el-option
                      v-for="classs in sClass"
                      :label="classs.name"
                      :value="classs.id">
                    </el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="姓名:">
                            <el-input v-model="formInline.student" placeholder="姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="指导老师:">
                            <el-input v-model="formInline.teacher" placeholder="指导教师"></el-input>
                    </el-form-item>
                   
                <el-form-item label="更新时间:">
                    <el-date-picker
                        v-model="formInline.data"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="timestamp"
                        :default-time="['00:00:00', '23:59:59']"
                        >
                    </el-date-picker>
                </el-form-item>
                 <el-form-item>
                          <el-button type="primary" @click="onSubmit" >查询</el-button>
                    </el-form-item>
            </el-form>
        
           
           
                    <litable :page="page" :colConfigs='tablist' :listdata='studentsList' :pagesize="pageInputOver">
            <el-table-column slot="opt" label="操作">
                    <template slot-scope="scope">
                    <el-button size="mini" @click="handleClick(scope.row,)">查看</el-button>
                    <!-- <el-button size="mini"  @click="handleClick(scope.row,),change='delect'">编辑</el-button> -->
                    </template>  
                </el-table-column>
                </litable>
           
                <el-footer>
<div class="block">
      <p>每页条数</p>
    <el-input v-model="pageInput" @change="pageSizeChange" class="page_input" size="mini"></el-input>
  <el-pagination
      @current-change="getather"
      :current-page.sync="currentPage"
      :page-size="pageInputOver"
      layout="prev, pager, next, jumper"
      :total="total">
    </el-pagination>
</div>
    </el-footer>
</div>
                   <div class="students" v-if="change!=='list'">
           
           <el-form  :model="students" label-position="right" label-width="100px" class="demo-form-inline" :disabled="change==='watch'">
         
                    <el-form-item label="学校:">
                            <el-input v-model="students.学校" placeholder="学校"></el-input>
                    </el-form-item>
               
                    <el-form-item label="班级:">
                    <el-select v-model="students.班级" placeholder="班级" size="medium">
                        <el-option label="区域一" value="shanghai"></el-option>
                        <el-option label="区域二" value="beijing"></el-option>
                    </el-select>
                    </el-form-item>
                    
                    <el-form-item label="姓名:">
                            <el-input v-model="students.姓名" placeholder="姓名"></el-input>
                    </el-form-item>
                     <el-form-item label="联系方式:">
                            <el-input v-model="students.联系方式" placeholder="联系方式"></el-input>
                    </el-form-item>
                     <el-form-item label="班级:">
                         <el-select v-model="students.入学年份" placeholder="入学年份">
                        <el-option label="区域一" value="shanghai"></el-option>
                        <el-option label="区域二" value="beijing"></el-option>
                    </el-select>
                    </el-form-item>
                    <el-form-item label="指导教师:">
                            <el-input v-model="students.指导教师" placeholder="指导教师"></el-input>
                    </el-form-item>
                     <el-form-item label="教师联系电话:">
                            <el-input v-model="students.教师联系电话" placeholder="教师联系电话"></el-input>
                    </el-form-item>
                    <el-form-item label="识字准确率:">
                            <el-input v-model="students.wordAccuracy" placeholder="识字准确率"></el-input>
                    </el-form-item>
                     <el-form-item label="识字星级:">
                            <el-input v-model="students.wordStar" placeholder="识字星级"></el-input>
                    </el-form-item>
                     <el-form-item label="阅读星级:">
                            <el-input v-model="students.articleStar" placeholder="阅读星级"></el-input>
                    </el-form-item>
                   
           </el-form>
                       <el-button type="primary" @click="back" class="goback">返回</el-button>
      </div>
      </div>
      <!-- <el-page-header @back="back"  content="学生信息" v-if="change!=='list'">
          </el-page-header> -->
     
        

</template>
<script>
import litable from '@/components/li-table'
  import {
    mapState,
    // mapMutations,
    mapActions
  } from 'vuex'
export default {
    data () {
        return {
              pageInputOver:20,
        pageInput:20,
             currentPage:'',
             role:'',
             change:'list',
             students:'',
             params :{
                   
                },
          classid:'',
             formInline: {
                 
                    // school: '',
                    // class:'',
                    // name:'',
                    // teacher:'',
                    // data: ''
                     page:1,
                    pageSize:20,
                    sort:'updateTime,desc'
            }, 
        }
    },
   async created () {
           if (this.$route.path=== '/学生信息查看') {
                 this.change='list'
                    this.role =JSON.parse( sessionStorage.getItem('role')).role
                 console.log(this.role)
                  
        this.formInline.page = sessionStorage.getItem('studentpage')
        this.currentPage = this.formInline.page
         this.FETCH_STUDENTS_LIST(this.formInline) 
                    if (this.role === 'teacher') {
                        this.FETCH_CLASS( this.studentsList[0].schoolId)      
                    }
                 await console.log('created',this.studentsList)
           } else {

                this.students=this.$route.query.row
                console.log(this.students)
                this.change='watch'
           }
    
    },
   async mounted(){
        this.find.pageSize = this.pageInput
          
    },
    methods: {
         ...mapActions('students', ['FETCH_STUDENTS_LIST','FETCH_CLASS']),
            pageSizeChange(value){
        console.log(value)
        this.pageInputOver = value
        this.formInline.pageSize = value
        this.FETCH_STUDENTS_LIST(this.formInline) 
    },
           getather(val){
        sessionStorage.setItem('studentpage',val)
        this.formInline.page =val
         this.FETCH_STUDENTS_LIST(this.formInline) 
            },
         back(){
          this.$router.go(-1)
            
         },
         changeClass(value){
             this.formInline.classId = value
         },
         changeSchoool(value){
             this.classid = ''
             this.formInline.classId = undefined
             this.FETCH_CLASS(value)
             console.log('学校啊嗷嗷啊啊啊',value)
                let obj = {};
                obj = this.school.find((item)=>{
                    return item.id === value;
                });
                this.formInline.school = obj.name
         },
      async   onSubmit(){
            this.formInline.page = 1
            this.currentPage = 1
            this.formInline.pageSize = this.pageInputOver
              // eslint-disable-next-line no-console
            console.log(this.formInline)
            if(this.formInline.data != undefined){
             this.formInline.beginTime = this.formInline.data[0]
             this.formInline.endTime = this.formInline.data[1]
           
             } else {
             this.formInline.beginTime =undefined
             this.formInline.endTime =undefined
             }
          await  this.FETCH_STUDENTS_LIST(this.formInline) 
            // this.classid = ''
            // this.formInline.classId = undefined
               console.log('onSubmit',this.studentsList)
         },
         handleClick(scope,stuts){
             // eslint-disable-next-line no-console
             console.log(scope,stuts)
               this.$router.push({
                                    name:'学生查看',
                                    query:{
                                        row: this.row = scope
                                    }
                                }) 
             
         }
    },
    computed: {
          ...mapState( 'students', ['studentsList','tablist','total','page','sClass','school']),
    },
    components: {
        litable
    }
}
</script>
<style lang="scss" scoped>
.list{
    // display: flex;
    // flex-direction: column;
    // // justify-items: 
}
.el-container{
    height: 100%
}

.el-main{
  
   height: 100%;
    overflow: auto;
}

.chaxun{
    float: left;
    margin: 20px 0;
}

.el-select{
    width: 100%;
}
.students{
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px 50px 20px 50px;
    background: #fff;
    width: 800px;
    .goback{
  
    }
}
.block{
    margin-top: 5px;
    float:right;
    display: flex;
    justify-content: center;
    align-items: center;
    .page_input{
        width: 50px;
        font-size: 14px;
       
        .el-input__inner{
            height: 30px;
        }
     
    }
}
</style>
